import { SMALL } from "shared/utils/constants";
import cx from "classnames";
import styles from "./Grid.module.css";

export const Grid = ({ children, size, columns = 3 }) => (
  <div
    className={cx(styles.container, {
      [styles.small]: size === SMALL,
      [styles.columns1]: columns === 1,
      [styles.columns2]: columns === 2,
      [styles.columns3]: columns === 3,
      [styles.columns4]: columns === 4,
    })}
  >
    {children}
  </div>
);
